module.exports = __webpack_public_path__ + "img/tab.954c66dd.svg";